import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-36 h-full queue" }
const _hoisted_2 = { class: "inner px-2 w-36 mt-10" }
const _hoisted_3 = { class: "scroll-area-inside" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["data-uuid", "onDragstart"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "w-full text-sm border-b border-black font-bold mb-2 mt-8 sticky" }
const _hoisted_8 = { class: "addAppointmentWrapper" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = { class: "relative flex flex-col justify-start items-start" }
const _hoisted_11 = ["id"]
const _hoisted_12 = ["id"]
const _hoisted_13 = ["onMousedown", "onTouchstart", "onMouseleave", "onMouseup", "onTouchcancel", "onTouchend", "onClick"]
const _hoisted_14 = { class: "text-xs text-gray-darker truncate select-none" }
const _hoisted_15 = { class: "flagsWrapper" }
const _hoisted_16 = ["id"]
const _hoisted_17 = ["id"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "text-xs text-gray-darker truncate" }
const _hoisted_20 = ["data-room-index", "onDragover", "onDragleave", "onDrop"]
const _hoisted_21 = {
  key: 0,
  class: "room-slots__cancel"
}
const _hoisted_22 = { class: "room-drag-warning__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_QueueCard = _resolveComponent("QueueCard")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_openBlock(), _createElementBlock("div", {
    key: _ctx.componentKey,
    id: "waiting-room",
    class: "flex h-full"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_SearchInput),
        _createElementVNode("div", _hoisted_3, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "w-full text-sm border-b border-black font-bold mb-2 sticky" }, " Arrived ", -1)),
          (_ctx.interactWithBoard)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredQueue, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.uuid,
                    draggable: "true",
                    "data-uuid": item.uuid,
                    onDragstart: ($event: any) => (_ctx.onNativeDragStart($event, item)),
                    onDragend: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onNativeDragEnd && _ctx.onNativeDragEnd(...args)))
                  }, [
                    _createVNode(_component_QueueCard, {
                      id: `queue-${i}`,
                      class: "mb-2",
                      "arrival-time": _ctx.$dayjs.min(
                    _ctx.$dayjs(item.arrived_at || undefined),
                    _ctx.$dayjs(item.checkedin_at || undefined)
                  ).toDate(),
                      appointment: item,
                      "appointment-time": item.starts_at,
                      "doctor-initials": _ctx.$filters.initials(_ctx.getDoctorName(item)),
                      "image-url": item.patient.avatar,
                      name: item.patient.name,
                      "new-patient": item.patient.is_new,
                      treatments: item.treatments,
                      uuid: item.uuid,
                      onClick: ($event: any) => (_ctx.openAppointmentDialog(item))
                    }, null, 8, ["id", "arrival-time", "appointment", "appointment-time", "doctor-initials", "image-url", "name", "new-patient", "treatments", "uuid", "onClick"])
                  ], 40, _hoisted_5))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.interactWithBoard)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredQueue, (item, i) => {
                  return (_openBlock(), _createBlock(_component_QueueCard, {
                    id: `queue-${i}`,
                    class: "mb-2",
                    "arrival-time": _ctx.$dayjs.min(
              _ctx.$dayjs(item.arrived_at || undefined),
              _ctx.$dayjs(item.checkedin_at || undefined)
            ).toDate(),
                    appointment: item,
                    "appointment-time": item.starts_at,
                    "doctor-initials": _ctx.$filters.initials(_ctx.getDoctorName(item)),
                    "image-url": item.patient.avatar,
                    key: `queue-${item.uuid}`,
                    name: item.patient.name,
                    "new-patient": item.patient.is_new,
                    treatments: item.treatments,
                    uuid: item.uuid
                  }, null, 8, ["id", "arrival-time", "appointment", "appointment-time", "doctor-initials", "image-url", "name", "new-patient", "treatments", "uuid"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _cache[2] || (_cache[2] = _createTextVNode(" Upcoming ", -1)),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_v_icon, {
                  size: 16,
                  onClick: _ctx.openCreateAppointmentModal
                }, {
                  default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                    _createTextVNode("mdi-plus", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.queueUpcoming, (item, i) => {
            return (_openBlock(), _createBlock(_component_QueueCard, {
              key: `queue-${item.uuid}`,
              id: `queue-${i}`,
              uuid: item.uuid,
              class: "mb-2",
              appointment: item,
              name: item.patient.name,
              "image-url": item.patient.avatar,
              "doctor-initials": _ctx.$filters.initials(_ctx.getDoctorName(item)),
              "appointment-time": item.starts_at,
              "new-patient": item.patient.is_new,
              treatments: item.treatments,
              allowMakeManual: "",
              onClick: ($event: any) => (_ctx.openAppointmentDialog(item))
            }, null, 8, ["id", "uuid", "appointment", "name", "image-url", "doctor-initials", "appointment-time", "new-patient", "treatments", "onClick"]))
          }), 128)),
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "w-full text-sm border-b border-black font-bold mb-2 mt-8 sticky" }, " Tomorrow ", -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.queueTomorrow, (item, i) => {
            return (_openBlock(), _createBlock(_component_QueueCard, {
              key: `queue-${item.uuid}`,
              id: `queue-${i}`,
              uuid: item.uuid,
              class: "mb-2",
              appointment: item,
              name: item.patient.name,
              "image-url": item.patient.avatar,
              "doctor-initials": _ctx.$filters.initials(_ctx.getDoctorName(item)),
              "appointment-time": item.starts_at,
              "new-patient": item.patient.is_new,
              treatments: item.treatments
            }, null, 8, ["id", "uuid", "appointment", "name", "image-url", "doctor-initials", "appointment-time", "new-patient", "treatments"]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_ctx.interactWithBoard)
        ? (_openBlock(), _createBlock(_component_draggable, {
            key: 0,
            class: _normalizeClass({ inert: _ctx.isDraggingQueuePatient }),
            "drag-class": _ctx.dragClass,
            group: _ctx.group,
            list: _ctx.filteredRooms,
            move: _ctx.onRoomPatientMoved,
            draggable: ".ableToDragAndDrop",
            onEnd: _ctx.onRoomPatientDragEnd,
            onStart: _ctx.onRoomPatientDragStart
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rooms, (room, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `room-header-${i + 1}`,
                  id: `room-${i}`,
                  class: _normalizeClass([{ 'last-room-height': i === _ctx.rooms.length - 1,
          'ableToDragAndDrop': _ctx.ableToDragAndDrop(room) }, "block block--header"]),
                  style: {"height":"68px"}
                }, [
                  _createElementVNode("div", {
                    id: `roomborder-${i}`
                  }, null, 8, _hoisted_12),
                  _createElementVNode("div", {
                    class: "block--header__text truncate cursor-pointer",
                    style: _normalizeStyle({
              backgroundColor: room.color,
              color: _ctx.$filters.foregroundColor(room.color)
            })
                  }, _toDisplayString(room.name.toUpperCase()), 5),
                  (!!_ctx.activeAppointment(room) && _ctx.filteredAppointments.find(a => a === room.uuid))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "flex flex-col p-1 w-full cursor-pointer",
                        onMousedown: ($event: any) => (_ctx.start(room)),
                        onTouchstart: ($event: any) => (_ctx.start(room)),
                        onMouseleave: ($event: any) => (_ctx.stop(room)),
                        onMouseup: ($event: any) => (_ctx.stop(room)),
                        onTouchcancel: ($event: any) => (_ctx.stop(room)),
                        onTouchend: ($event: any) => (_ctx.stop(room)),
                        onClick: _withModifiers(($event: any) => (_ctx.$store.dispatch('selectAppointment', { appointment: _ctx.activeAppointment(room) })), ["stop"])
                      }, [
                        _createVNode(_component_Avatar, {
                          size: "24",
                          src: _ctx.activeAppointment(room).patient.avatar,
                          alt: _ctx.activeAppointment(room).patient.name
                        }, null, 8, ["src", "alt"]),
                        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.patientName(_ctx.activeAppointment(room).patient.name)), 1),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", null, [
                            (_ctx.activeAppointment(room).has_flags)
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 0,
                                  color: "red-darken-2",
                                  size: 18
                                }, {
                                  default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                    _createTextVNode("mdi-flag", -1)
                                  ]))]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", null, [
                            (_ctx.activeAppointment(room).has_traction_flags)
                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                  key: 0,
                                  color: "green-darken-2",
                                  size: 18
                                }, {
                                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                    _createTextVNode("mdi-flag", -1)
                                  ]))]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ], 40, _hoisted_13))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_11))
              }), 128))
            ]),
            _: 1
          }, 8, ["class", "drag-class", "group", "list", "move", "onEnd", "onStart"]))
        : _createCommentVNode("", true),
      (!_ctx.interactWithBoard)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.rooms, (room, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `room-header-${i + 1}`,
              id: `room-${i}`,
              class: _normalizeClass([{ 'last-room-height': i === _ctx.rooms.length - 1 }, "block block--header"]),
              style: {"height":"68px"}
            }, [
              _createElementVNode("div", {
                id: `roomborder-${i}`
              }, null, 8, _hoisted_17),
              _createElementVNode("div", {
                class: "block--header__text truncate",
                style: _normalizeStyle({
              backgroundColor: room.color,
              color: _ctx.$filters.foregroundColor(room.color)
            })
              }, _toDisplayString(room.name.toUpperCase()), 5),
              (!!_ctx.activeAppointment(room) && _ctx.filteredAppointments.find(a => a === room.uuid))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["flex flex-col p-1 w-full cursor-pointer", !!_ctx.filteredAppointments.find(a => a === room.uuid) ? 'filtered': null]),
                    onClick: _withModifiers(($event: any) => (_ctx.$store.dispatch('selectAppointment', { appointment: _ctx.activeAppointment(room) })), ["stop"])
                  }, [
                    _createVNode(_component_Avatar, {
                      size: "24",
                      src: _ctx.activeAppointment(room).patient.avatar,
                      alt: _ctx.activeAppointment(room).patient.name
                    }, null, 8, ["src", "alt"]),
                    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.patientName(_ctx.activeAppointment(room).patient.name)), 1)
                  ], 10, _hoisted_18))
                : _createCommentVNode("", true)
            ], 10, _hoisted_16))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      id: "room-slots",
      class: _normalizeClass(["room-slots__container", {
        [_ctx.isDraggingQueuePatientGhostClass]: _ctx.isDraggingQueuePatient,
        'room-slots--active': _ctx.isDraggingQueuePatient,
        'room-slots--inactive': !_ctx.isDraggingQueuePatient
      }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roomSlots, (slot, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: slot.uuid,
          class: "room-slots__slot",
          "data-room-index": index,
          onDragover: _withModifiers(($event: any) => (_ctx.onSlotDragOver($event, index)), ["prevent"]),
          onDragleave: ($event: any) => (_ctx.onSlotDragLeave($event, index)),
          onDrop: _withModifiers(($event: any) => (_ctx.onSlotDrop($event, index)), ["prevent"])
        }, null, 40, _hoisted_20))
      }), 128))
    ], 2),
    (_ctx.isDraggingQueuePatient)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21))
      : _createCommentVNode("", true),
    (_ctx.dragWarning)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "room-drag-warning",
          style: _normalizeStyle({ top: `${_ctx.dragWarning.index * 68}px` })
        }, [
          _createElementVNode("span", _hoisted_22, [
            _createVNode(_component_v_icon, {
              color: "#3d2e00",
              size: "18",
              class: "mr-1"
            }, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("mdi-alert", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(" " + _toDisplayString(_ctx.dragWarning.text), 1)
          ])
        ], 4))
      : _createCommentVNode("", true)
  ]))
}